/**
 * Service to fetch cart summary statistics
 */

import axios from "axios";

/**
 * Fetch cart summary statistics from the server
 * @param {string} baseUrl - The base URL for the API
 * @param {Date} startDate - Start date for the statistics period
 * @param {Date} endDate - End date for the statistics period
 * @param {string} cartFilter - Cart filter type ('all_active', 'all', or specific cart ID)
 * @returns {Promise<Object>} Cart summary statistics data
 */
export const getCartSummaryStatistics = async (baseUrl, startDate, endDate, cartFilter = 'all_active') => {
  try {
    const requestData = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      type: 'cart_summary',
      cartFilter: cartFilter
    };

    console.log('Fetching cart summary statistics:', requestData);

    const response = await axios.post(`${baseUrl}/admin/statistics_cart_summary`, requestData);

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = response.data;
    
    if (data.success && data.cartSummary) {
      return data.cartSummary;
    } else {
      console.warn('No cart summary data received from server');
      return null;
    }
  } catch (error) {
    console.error('Error fetching cart summary statistics:', error);
    // Return null to let the component handle mock data loading
    return null;
  }
};

export default getCartSummaryStatistics;
